import { Card } from "antd";
import "../../styles/doctorCard.scss";
import './serviceCard.scss';
import { $host } from "../../http";

const ServiceCard = ({ service }) => {
  
  const language = localStorage.getItem("lang") || "AM";
  const name = `name${language.toUpperCase()}`;
  const description = `description${language.toUpperCase()}`;

  return (
    <Card className="service-card" hoverable>
      <img
        src={`${$host.defaults.baseURL}photos/categories/${service.image}`}
        className="service-image"
      />
      <div className="doctor-info">
        <h3>{service[name]}</h3>
        <div className="scrollable-description">
          {service[description]}
        </div>
       </div>
    </Card>
  );
};

export default ServiceCard;